(() => {
  const SELECTOR = '[data-lazy-bg]';
  const MOBILE_QUERY = '(max-width: 749px)';

  const resolveUrl = (el) => {
    const desktop = el.dataset.lazyBgDesktop || '';
    const mobile = el.dataset.lazyBgMobile || '';
    if (mobile && window.matchMedia(MOBILE_QUERY).matches) return mobile;
    return desktop || mobile;
  };

  const applyBackground = (el) => {
    if (el.dataset.lazyBgLoaded === 'true') return;
    const url = resolveUrl(el);
    if (!url) return;

    el.dataset.lazyBgLoaded = 'true';
    const cssVar = el.dataset.lazyBgVar;
    if (cssVar) {
      el.style.setProperty(cssVar, `url("${url}")`);
    } else {
      el.style.backgroundImage = `url("${url}")`;
    }
  };

  const observe = () => {
    const nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) {
      nodes.forEach(applyBackground);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          applyBackground(entry.target);
        });
      },
      { rootMargin: '600px 0px', threshold: 0.01 }
    );

    nodes.forEach((el) => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }
})();
